import Splide from '@splidejs/splide';
import "./components/item/ItemImageCarousel";
import "./components/item/Carousel";
import "./components/events/events";

import LazyLoad from "vanilla-lazyload";


/**
 * This is our clientside javascript entry point
 */

// The Ceres bundle provides Vue, we do not need to bundle it ourself
const Vue = window.Vue;
var initShopbuilderScripts = false;
/*
export default {
    mounted() {
     
    }
  }
*/

function setCookie(name,value,days) {
    var expires = "";
    if (days) {
        var date = new Date();
        date.setTime(date.getTime() + (days*24*60*60*1000));
        expires = "; expires=" + date.toUTCString();
    }
    document.cookie = name + "=" + (value || "")  + expires + "; path=/";
}
function getCookie(name) {
    var nameEQ = name + "=";
    var ca = document.cookie.split(';');
    for(var i=0;i < ca.length;i++) {
        var c = ca[i];
        while (c.charAt(0)==' ') c = c.substring(1,c.length);
        if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length,c.length);
    }
    return null;
}
let previousScrollPosition = 0;

const isScrollingDown = () => {
  let goingDown = false;

  let scrollPosition = window.pageYOffset;

  if (scrollPosition > previousScrollPosition) {
    goingDown = true;
  }

  previousScrollPosition = scrollPosition;

  return goingDown;
};

const handleScroll = () => {
    var newBgPos = $('.bg-heart').css('backgroundPositionX');
    if (isScrollingDown()) {
        var newPos = parseInt(newBgPos) + 5;
            $('.bg-heart').css('backgroundPositionX', newPos +"px")
        
    } else {
        var newPos = parseInt(newBgPos) - 5;
        $('.bg-heart').css('backgroundPositionX', newPos +"px")
        //$('.bg-heart')[0].style.backgroundPositionX = newPos +"px";
    }
};

window.homeSliderElement = null;
function initHomeSlider(withAutoplay){
    console.log(withAutoplay)
    console.log("withAutoplay")
    if(homeSliderElement != null){
        homeSliderElement.destroy();
    }

    
    var initHomeSlider = false;
    var homeSliderInterval = setInterval(function () {
        if($('.splide-slider').length > 0 && !initHomeSlider){         
            initHomeSlider = false;
            $('.splide-slider').each(function(){

                
                if($('.section-ruf-tassen').length > 0){
                    homeSliderElement = new Splide(this,{
                        mediaQuery: 'min',
                        type   : 'loop',
                        pagination: false,
                        arrows: true,
                        perPage: 1,
                        perMove: 1,
                        autoplay: withAutoplay,
                        reducedMotion: {
                            interval: 4000,
                            speed: 800,
                            autoplay: "play"
                        }
                    }).mount();
                }else{
                    homeSliderElement = new Splide(this,{
                        mediaQuery: 'min',
                        type   : 'loop',
                        pagination: true,
                        arrows: false,
                        perPage: 1,
                        perMove: 1,
                        autoplay: withAutoplay,
                        reducedMotion: {
                            interval: 4000,
                            speed: 800,
                            autoplay: "play"
                        },
                        breakpoints:{
                            1200: {
                                arrows: true,
                                pagination: false,
                            },
                        }
                    }).mount();
                }
            })
            clearInterval(homeSliderInterval); 
        }
    }, 100);
}
function initSlider(){
 
    if($('.splide-slider-cats').length > 0){
        new Splide('.splide-slider-cats', {
            fixedWidth: '200px',
            drag   : 'free',
            gap    : '30px',
            mediaQuery: 'min',
            pagination: false,
            arrows: false,
            breakpoints:{
                768: {
                    perPage: 3,
                    fixedWidth: false,
                    arrows: true
                },
                992: {
                    perPage: 4,
                    fixedWidth: false,
                    arrows: true
                },
            }
          }).mount();
    }
    
    if($('.splide-slider-stepbystep').length > 0){
        new Splide('.splide-slider-stepbystep', {
            fixedWidth: '252px',
            drag   : 'free',
            gap    : '15px',
            mediaQuery: 'min',
            pagination: false,
            arrows: false,
            breakpoints:{
                768: {
                    perPage: 3,
                    fixedWidth: false,
                    arrows: true,
                },
                992: {
                    destroy: true,
                    gap    : '30px',
                },
            }
          }).mount();
    }
    if($('.splide-slider-rezept-simple').length > 0){
        new Splide('.splide-slider-rezept-simple', {
            fixedWidth: '200px',
            drag   : 'free',
            gap    : '30px',
            mediaQuery: 'min',
            pagination: false,
            arrows: false,
            breakpoints:{
                768: {
                    perPage: 3,
                    fixedWidth: false,
                    arrows: true
                }
            }
          }).mount();
    }
    /*if($('.splide-slider-cakeboxes').length > 0){
        new Splide('.splide-slider-cakeboxes', {
            fixedWidth: '200px',
            drag   : 'free',
            mediaQuery: 'min',
            pagination: false,
            arrows: false,
            breakpoints:{
                768: {
                    fixedWidth: '282px',
                }
            }
          }).mount();
    }*/
    if($('.splide-slider-cakeboxes').length > 0){
        $('.splide-slider-cakeboxes').each(function(){
            new Splide(this, {
                fixedWidth: '200px',
                drag   : 'free',
                mediaQuery: 'min',
                pagination: false,
                arrows: false,
                gap: '20px',
                breakpoints:{
                    768: {
                        fixedWidth: '282px',
                    },
                    1200: {
                        destroy: true
                    }
                    
                }
              }).mount();
        })
        
    }
    if($('.splide-slider-cakevideos').length > 0){
        var splideVideos = new Splide('.splide-slider-cakevideos', {
            type   : 'loop', 
            pagination: false,
            arrows: true,      
            rewind: true,
            perPage: 1,
            mediaQuery: 'min',
            breakpoints:{
                768: {
                    gap: "30%",
                    padding: '30%',
                }
            }
          }).mount();

          /*splideVideos.on( 'move', function (newIndex, prevIndex, destIndex) {
            $('.splide__slide').removeClass('no-scale').removeClass('is-right').removeClass('is-left');
            //$(`#splide01-slide0${destIndex}`).addClass('is-center')
            //$(`#splide01-slide0${prevIndex}`).removeClass('is-center')
            //$(`#splide01-slide0${destIndex}`).removeClass('is-center')
            $('.splide-slide-'+(newIndex+1)).addClass('scale-to');


            if(newIndex == 0){
                //weisse tasse
                $('.splide-slide-3').addClass('no-scale');
                $('.splide-slide-2').addClass('no-scale');
            }
            if(newIndex == 1){
                $('.splide-slide-1').addClass('no-scale');
                $('.splide-slide-3').addClass('no-scale');
            }
            if(newIndex == 2){
                $('.splide-slide-2').addClass('no-scale');
            }
            if(newIndex == 3){
                $('.splide-slide-3').addClass('no-scale');
                $('.splide-slide-1').addClass('no-scale');
            }
          } );*/
    }
    if($('.splide-slider-cakes').length > 0){
        
        $('.splide-slider-cakes').each(function(){
            new Splide(this, {
                type   : 'loop',
                pagination: false,
                arrows: true,
                rewind: true,
                perPage: 1,
                mediaQuery: 'min',
                breakpoints:{
                    768: {
                        gap: "5%",
                        padding: '25%',
                    }
                }
              }).mount();
        })
        
    }
    if($('.splide-slider-kids-package').length > 0){
        new Splide('.splide-slider-kids-package', {   
            type   : 'loop',
            pagination: false,
            arrows: true,
            perPage: 3,
            perMove: 1,
            mediaQuery: 'max',
            breakpoints:{
                767: {
                    destroy: true,
                }
            }
          }).mount();
    }
    
}

$(document).ready(function(){
  
    const lazyContent = new LazyLoad({
        elements_selector: '.rf-lazy',
        use_native: false,
        threshold: 500 // <-- there you go
    });
    
    

    initSlider(); 
    if($('.is-shopbuilder').length <= 0){
        initHomeSlider(true);
    }
    
})
 	
$(document).on("shopbuilder.after.drop shopbuilder.after.widget_replace", function(event, eventData, widgetElement)
{
   if($(widgetElement).hasClass('splide-slider')){
        initHomeSlider(false);
   }
});
$(document).on( "click", ".ts-rating-item", function(event) {
    
    if(!$('.nav-tabs .nav-item:last-child a').hasClass('active')){
        //tab-pane
        $('.nav-tabs .nav-item:last-child a')[0].click();
        var offsetTopTab = $('.tab-content').offset().top - 100;
        if($(document).width() < 768){
            offsetTopTab = $('.tab-content').offset().top + 200;
        }
        $("html, body").animate({ scrollTop: offsetTopTab }, 700);
    }
    

});
document.onreadystatechange = function () {
    if (document.readyState == "complete") {
        if($('.category-224').length > 0){
            window.addEventListener("scroll", handleScroll);
        }
        

        if($('.splide-rezept-slider-item').length > 0){
            new Splide('.splide-rezept-slider-item',{
                fixedWidth: '180px',
                drag   : 'free',
                gap    : '30px',
                perPage: 1,
                arrows: false,
                gap    : '15px',
                mediaQuery: 'min',
                pagination: false,
                breakpoints:{
                    768: {
                        fixedWidth: false,
                        pagination: true
                    }
                }
            }).mount();
        }
        /*if($('.category-list-item').length > 0){
            var summaryBadgeCat = new productStickerSummary();
            $('.category-list-item').each(function(){
                var itemId = $(this).data('itemid');
                var targetClass = ".ts-reviews-placeholder-"+$(this).data('itemid');
                summaryBadgeCat.showSummary({
                    'tsId': 'X24F440F634E19777117B620C5F660235',
                    'sku': "'"+itemId+"'",
                    'element': targetClass,
                    'starColor': '#FFDC0F',
                    'starSize': '14px',
                    'fontSize': '12px',
                    'showRating' : 'true',
                    'scrollToReviews' : 'false',
                    'enablePlaceholder': 'true'
                });
            })
           
        }*/
    }
  }
/*
$(document).on("shopbuilder.after.drop shopbuilder.after.widget_replace", function(event, eventData, widgetElement)
{
    $('.owl-widget-home-carousel').owlCarousel({
            loop:true,
            nav:true,
            items: 1
        })
   console.log("DROP")
});*/
$(document).on("shopbuilder.before.viewUpdate shopbuilder.after.viewUpdate", function(event, eventData, widgetElement)
{
    if(!initShopbuilderScripts){
        const ssIntervall = setInterval(function(){
            if($('.splide').length > 0){
                initSlider();
                const lazyContent = new LazyLoad({
                    elements_selector: '.rf-lazy',
                    use_native: false // <-- there you go
                });
                clearInterval(ssIntervall); 
            }
            
        }, 100);
        
        initShopbuilderScripts = true;
    }
    
});
// when the active dropzone in the shopbuilder changes
/*
$(document).on("shopbuilder.after.activate-container", (event, data) =>
{
    console.log(data?.container );
});*/
setInterval(function(){ 
    if($(document).width()<768){
        var elem = $('.top-header-usp .active-point');
        $(elem).removeClass('active-point')
        if($(elem).next('li').length>0){
            $(elem).next('li').addClass('active-point');
        }else{
            $('.top-header-usp li').first().addClass('active-point');
        }

    }
}, 3000);


if($('.isB2B').length > 0){

    const dfLayerOptions = {
      installationId: '5409fc5c-b058-4d81-8405-66649521333d',
      zone: 'eu1'
    };
    (function (l, a, y, e, r, s) {
      r = l.createElement(a); r.onload = e; r.async = 1; r.src = y;
      s = l.getElementsByTagName(a)[0]; s.parentNode.insertBefore(r, s);
    })(document, 'script', 'https://cdn.doofinder.com/livelayer/1/js/loader.min.js', function () {
      doofinderLoader.load(dfLayerOptions);
    });
  }else{
    const dfLayerOptions = {
      installationId: '3e1af9e9-56c4-4517-979c-457734a07c11',
      zone: 'eu1'
    };
    (function (l, a, y, e, r, s) {
      r = l.createElement(a);
      r.onload = e;
      r.async = 1;
      r.src = y;
      s = l.getElementsByTagName(a)[0];
      s.parentNode.insertBefore(r, s);
    })(document, 'script', 'https://cdn.doofinder.com/livelayer/1/js/loader.min.js', function () {
      doofinderLoader.load(dfLayerOptions);
    });  
  }



/*
$.ajax({
    type: "GET",
    url: '/rest/vatcheck/',
    dataType: 'json',
    success: function(response){ console.log(response) }
  });*/
window.setCookie = setCookie;
window.getCookie = getCookie;
window.initSlider = initSlider;
window.initHomeSlider = initHomeSlider;